/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { useMemo } from 'react';
import LinkIcon from '@atlaskit/icon/core/migration/link';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { SmartLinkPosition, SmartLinkSize } from '../../../../../constants';
import AtlaskitIcon from '../../common/atlaskit-icon';
import ImageIcon from '../../common/image-icon';
import { getIconSizeStyles, getIconWidth, getTruncateStyles } from '../../utils';
var getPositionStyles = function getPositionStyles(position) {
  switch (position) {
    case SmartLinkPosition.Center:
      return css({
        alignSelf: 'center'
      });
    case SmartLinkPosition.Top:
    default:
      return css({
        alignSelf: 'flex-start',
        margin: 0
      });
  }
};
var getIconStyles = function getIconStyles(position, width) {
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    css(getPositionStyles(position), getIconSizeStyles(width))
  );
};
var getCustomRenderStyles = function getCustomRenderStyles(value) {
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    css(getTruncateStyles(1, value), {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      lineHeight: value,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      fontSize: value,
      textAlign: 'center',
      textOverflow: 'clip',
      WebkitBoxOrient: 'unset',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
      span: {
        margin: 0,
        padding: 0,
        verticalAlign: 'baseline'
      }
    })
  );
};
var renderAtlaskitIcon = function renderAtlaskitIcon(icon, testId) {
  if (icon) {
    return jsx(AtlaskitIcon, {
      icon: icon,
      testId: "".concat(testId, "-icon")
    });
  }
};
var renderDefaultIcon = function renderDefaultIcon(label, testId) {
  return jsx(LinkIcon, {
    label: label,
    testId: "".concat(testId, "-default"),
    color: "currentColor"
  });
};
var renderImageIcon = function renderImageIcon(defaultIcon, url, testId) {
  if (url) {
    return jsx(ImageIcon, {
      defaultIcon: defaultIcon,
      testId: testId,
      url: url
    });
  }
};

/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param {IconProps} IconProps - The props necessary for the Icon element.
 * @see LinkIcon
 */
var Icon = function Icon(_ref) {
  var icon = _ref.icon,
    overrideIcon = _ref.overrideIcon,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Link' : _ref$label,
    name = _ref.name,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? SmartLinkPosition.Top : _ref$position,
    overrideCss = _ref.overrideCss,
    render = _ref.render,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? SmartLinkSize.Medium : _ref$size,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-element-icon' : _ref$testId,
    url = _ref.url;
  var element = useMemo(function () {
    var defaultIcon = renderDefaultIcon(label, testId);
    return overrideIcon || (render === null || render === void 0 ? void 0 : render()) || renderImageIcon(defaultIcon, url, testId) || renderAtlaskitIcon(icon, testId) || defaultIcon;
  }, [overrideIcon, icon, label, render, testId, url]);
  var width = getIconWidth(size);
  var styles = getIconStyles(position, width);
  var renderStyles = render ? getCustomRenderStyles(width) : undefined;
  return jsx("div", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
    css: [styles, renderStyles, overrideCss],
    "data-fit-to-content": true,
    "data-smart-element": name,
    "data-smart-element-icon": true,
    "data-testid": testId
  }, element);
};
export default Icon;